import {SET_API_TOKEN} from "./actionTypes";

export const setApiToken = (content) => ({
  type: SET_API_TOKEN,
  payload: content
});
